import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  Autocomplete,
  TextField,
  TablePagination,
  Box,
  Typography,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  RadioGroup,
  FormControlLabel,
  Radio,
  DialogActions,
  Grid,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import Switch from "@mui/material/Switch";
import {
  ApiGetAllRoles,
  ApiGetAdminList,
  ApiPutUpdateAdminRole,
  ApiPutUpdateAdminStatus,
  ApiGetShoppersApplication,
  ApiPutUpdateShopperApplicationStatus,
  ApiGetDisabledTrainings,
  ApiUpdateIsTrainingRequired,
} from "../../../apiService/Core/Apicall.tsx";
import { toast } from "react-toastify";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

const stateOptions = [
  { label: "Victoria", value: "VIC" },
  { label: "Western Australia", value: "WA" },
  { label: "South Australia", value: "SA" },
  { label: "Queensland", value: "QLD" },
  { label: "Australian Capital Territory", value: "ACT" },
  { label: "New South Wales", value: "NSW" },
  { label: "Tasmania", value: "TAS" },
  { label: "Northern Territory", value: "NT" },
];

const statusOptions = [
  { label: "Pending", value: "pending" },
  { label: "Reject", value: "reject" },
];

const DisabledTraining: React.FC = () => {
  const [ShopperDetails, setShopperDetails] = useState<any>([]);
  const [datalength, setdatalength] = useState<any>(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [state, setState] = useState<any>("");
  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());

  useEffect(() => {
    const fetchData = async () => {
      await handleGetShoppers();
    };
    fetchData();
    return () => { };
  }, [rowsPerPage, page, state, selectedDate]);



  const handleGetShoppers = async () => {
    let queryParams = `?jobMonth=${selectedDate && selectedDate?.getMonth() + 1}&jobYear=${selectedDate?.getFullYear()}&offset=${page * rowsPerPage}&limit=${rowsPerPage}`;
    try {
      const response: any = await ApiGetDisabledTrainings(queryParams);
      setdatalength(response.count);
      setShopperDetails(response.data);
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  // ------------------------------------------- Chnage Pagination -----------------------------------------------
  const handleChangePage = (_event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleTrainingStatusChange = async (allocationId:number, userId:number) => {  
          const isConfirmed = window.confirm( "Are you sure you want to enable training for this shopper?");
  
          if (isConfirmed) {
              try {
                  const data = `?allocationId=${allocationId}&isTrainingRequired=true&shopperUserId=${userId}&modifiedBy=${Number(localStorage.getItem("userId"))}`
                  const res = await ApiUpdateIsTrainingRequired(data)
                  toast.success(res?.message);
                  if(res?.status){
                    handleGetShoppers()
                  }
              } catch (error: any) {
                  toast.error(error);
                  console.error(error);
              }
          }
      };

  return (
    <div className="w-100 p-2">
      <Box className='bg-light p-3 border-10'>
        {/* <Grid container className='w-100 mb-4' gap={2}>
          <Grid flexDirection={{xs:"column",md:"row"}} className='mb-4 d-flex  align-items-center' gap={2} size={{ xs: 12, md: "auto" }} order={{ xs: 2, md: 1 }}>
            <FormControl size="small" sx={{ width: { xs: "100%", md: 180 }}}>
              <Autocomplete
                disablePortal
                id="mm-autocomplete"
                options={stateOptions}
                getOptionLabel={(option: any) => `${option?.label}`}
                value={stateOptions.find((option: any) => option.value === state) || null}
                onChange={(event, newValue: any) => {
                  setState(newValue?.value || null)
                }}
                defaultValue=""
                renderInput={(params) => <TextField {...params} label="Select State" />}
                size="small"
              />
            </FormControl>
            <FormControl size="small" sx={{ width: { xs: "100%", md: 180 }}}>
              <TextField sx={{
                "input": { padding: '9px' }, "& .MuiInputLabel-root": {
                  transform: "translate(14px, 10px) scale(1)",
                  "&.MuiInputLabel-shrink": {
                    transform: "translate(14px, -9px) scale(0.75)"
                  }
                }
              }} value={searchShopper} label="Search Shopper" onChange={(e) => { setsearchShopper(e.target.value) }} />
            </FormControl>
            <FormControl size="small" sx={{ width: { xs: "100%", md: 180 }}}>
              <Autocomplete
                disablePortal
                disableClearable
                id="status-autocomplete"
                options={statusOptions}
                getOptionLabel={(option: any) => option.label}
                value={statusOptions.find((option) => option.value === status) || null}
                onChange={(event, newValue: any) => setStatus(newValue?.value || "")}
                renderInput={(params) => <TextField {...params} label="Select Status" />}
                size="small"
              />
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, md: "grow" }} order={{ xs: 1, md: 2 }}>
            <Typography className="fs-42 text-center">Shopper Applications</Typography>
          </Grid>
        </Grid> */}
        <div className="d-flex mb-5">
          <Typography flex={1} className="fs-42 text-center">Disabled Training</Typography>
          <Box sx={{ alignItems: 'flex-end', marginRight: 1 }}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                views={["month", "year"]}
                label=""
                value={selectedDate}
                onChange={(newDate) => setSelectedDate(newDate)}
                format="MM/yyyy"
                sx={{
                  width: "auto",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 1,
                  }
                }}
              />
            </LocalizationProvider>
          </Box>
        </div>
        <Box className='w-100' overflow={'auto'}>
          <Table>
            <TableHead>
              <TableRow className="table-row-background">
                {[
                  "First Name",
                  "Last Name",
                  "Email",
                  "Client Group",
                  "Entity Name",
                  "Site Name",
                  "Training Required",
                ].map((item, index) => (
                  <TableCell key={index} style={{ color: "#fff" }}>
                    {item}
                  </TableCell>
                ))}
                {/* <TableCell></TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {ShopperDetails?.map((shopper: any) => {

                return (
                  <TableRow>
                    <TableCell>{shopper.firstName}</TableCell>
                    <TableCell>{shopper.lastName}</TableCell>
                    <TableCell>{shopper.emailId}</TableCell>
                    <TableCell>{shopper.allocationClientGroup}</TableCell>
                    <TableCell>{shopper.entityName}</TableCell>
                    <TableCell>{shopper.venueName}</TableCell>
                    <TableCell>
                      <Switch
                        checked={shopper?.isTrainingRequired == 1}
                        // disabled
                        onChange={(e) =>
                          handleTrainingStatusChange(parseInt(shopper.allocationId),parseInt(shopper?.userId))
                        }
                      />
                    </TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </Box>
      </Box>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={datalength}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
};

export default DisabledTraining;
